<ul class="nav first-level tw:flex tw:list-none tw:m-0 tw:p-0 tw:max-h-[6.4rem]" role="menubar">
  <!--
  "Virtual" menu items that are always hidden.
  Used for size measurement. The "virtual" class is required for cacheMenuWidths() querySelector.
  -->
  @for (item of menuItems; track item) {
    <li class="virtual tw:absolute tw:left-0 tw:invisible" role="none">
      <a class="nav-item tw:whitespace-nowrap" role="none">
        <ng-container [ngTemplateOutlet]="item.content" />
      </a>
      <ng-container [ngTemplateOutlet]="item.secondary" />
    </li>
  }

  <!-- Mobile menu -->
  @if (navbar.isBurgerMenuBpMatched$ | async) {
    <li
      class="menudrop dropdown"
      role="none"
      diVudDropdown
      #burgerMenuDropdown="diVudDropdown"
      [class.open]="burgerMenuDropdown.isOpen$ | async"
    >
      <a
        class="dropdown-toggle"
        id="vud-navbar-mobile-menu"
        href="#"
        role="menuitem"
        aria-haspopup="true"
        diVudDropdownToggle
        draggable="false"
      >
        <span>{{ menuLabel }}</span>
        <i class="icon-align-justify"></i>
      </a>
      <ul class="dropdown-menu is-mobile" role="menu" aria-labelledby="vud-navbar-mobile-menu" diVudDropdownMenu>
        <!-- Brand information that's visible only inside burger menu -->
        @if (navbar.brandOptions!.length > 0) {
          <li class="dropdown navbar-brand" role="none" [class.is-open]="brandOptionsOpen">
            <a
              class="dropdown-toggle dropped-apps-toggle"
              role="button"
              [attr.aria-expanded]="brandOptionsOpen"
              (click)="toggleBrandOptions()"
            >
              {{ activeBrandOption?.label }}
              <span class="caret"></span>
            </a>
          </li>
          @if (brandOptionsOpen) {
            @for (brandOption of navbar.brandOptions; track brandOption) {
              @if (!brandOption.active) {
                <li role="none" [class.active]="brandOption.active">
                  <a
                    role="menuitem"
                    [attr.aria-label]="brandOption.label"
                    [attr.href]="brandOption.href"
                    [class.active]="brandOption.active"
                    (click)="brandOption.click.emit($event)"
                  >
                    <ng-template [ngTemplateOutlet]="brandOption.content" />
                  </a>
                </li>
              }
            }
          }
        }
        <!-- All menu options -->
        @if (!brandOptionsOpen) {
          @for (item of menuItems; track item; let i = $index) {
            <li
              role="none"
              diVudDropdown
              #subMenuDropdown="diVudDropdown"
              [class.active]="item.isActive$ | async"
              [class.is-open]="subMenuDropdown.isOpen$ | async"
              [class.second-level-children]="!!item.secondaryMenu?.menuItems?.length"
            >
              <a
                class="nav-item"
                [attr.aria-current]="item.isActive$ | async"
                [attr.href]="item.secondaryMenu?.menuItems?.length ? null : item.href"
                [class.has-children]="!!item.secondaryMenu?.menuItems?.length"
                (click)="onMobileMenuOptionClick($event, item, subMenuDropdown)"
              >
                <ng-container [ngTemplateOutlet]="item.content" />
                @if (item.secondaryMenu?.menuItems?.length) {
                  <span class="caret"></span>
                }
              </a>
              @if (item.secondaryMenu?.menuItems?.length) {
                <di-navbar-secondary-menu-mobile
                  [menuItems]="item.secondaryMenu.menuItems"
                  [parentLabel]="item.label"
                  (menuItemClick)="onMobileSecondaryMenuItemClick()"
                />
              }
            </li>
          }
        }
      </ul>
    </li>
  }

  <!-- Desktop menu -->
  @if ((navbar.isBurgerMenuBpMatched$ | async) === false) {
    @for (item of menuItems; track item; let i = $index) {
      @if (!hiddenMenuItems[i]) {
        <li role="none" [class.active]="item.isActive$ | async">
          <a
            class="nav-item"
            role="menuitem"
            [attr.aria-current]="item.isActive$ | async"
            [attr.href]="item.href"
            (click)="item.click.emit($event)"
          >
            <ng-container [ngTemplateOutlet]="item.content" />
          </a>
          <ng-container [ngTemplateOutlet]="item.secondary" />
        </li>
      }
    }
    <!-- "More" button for opening the hidden menu -->
    @if (anyHiddenMenuItem) {
      <li class="menudrop dropdown" role="none" [class.open]="moreMenuOpen">
        <!--
        note: `[attr.role]="'menuitem'"` is intentionally used to have a higher specificity,
        otherwise `cdkMenuTriggerFor` takes over and sets the role to `button`, yikes!
        -->
        <a
          class="dropdown-toggle"
          id="vud-navbar-more-menu"
          href="#"
          draggable="false"
          #moreMenuTrigger="cdkMenuTriggerFor"
          [attr.aria-haspopup]="anyHiddenMenuItem"
          [attr.role]="'menuitem'"
          [cdkMenuPosition]="moreMenuPosition"
          [cdkMenuTriggerFor]="moreMenu"
          (cdkMenuClosed)="moreMenuOpen = false"
          (cdkMenuOpened)="moreMenuOpen = true"
          (click)="$event.preventDefault()"
        >
          <span class="hidden">{{ menuLabel }}</span>
          <i class="icon-align-justify"></i>
        </a>
        <ng-template #moreMenu>
          <ul class="vud-more-menu dropdown-menu" aria-labelledby="vud-navbar-more-menu" cdkMenu>
            <!-- Hidden menu options that didn't fit in the main menu bar -->
            @for (item of menuItems; track item; let i = $index) {
              @if (hiddenMenuItems[i]) {
                <li role="none" [class.active]="item.isActive$ | async">
                  <a
                    class="nav-item"
                    cdkMenuItem
                    [attr.aria-current]="item.isActive$ | async"
                    [attr.href]="item.href"
                    (click)="item.click.emit($event)"
                  >
                    <ng-container [ngTemplateOutlet]="item.content" />
                  </a>
                  <ng-container [ngTemplateOutlet]="item.secondary" />
                </li>
              }
            }
          </ul>
        </ng-template>
      </li>
    }
  }
</ul>
